import { Select, TextField, FormControl } from "@material-ui/core";
import { connect } from "formik";
import React, { Component } from "react";
import { Form, Col, Row, Button } from "react-bootstrap";
import { getCountries } from "react-phone-number-input/input";
import { withRouter } from "react-router-dom";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";

class SuperAdminCreateOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      takeaway: 0,
      ordertype: 0,
      vehicletype: 0,
      deliverytype: 0,
    };
  }
  render() {
    const { takeaway, ordertype, vehicletype, deliverytype } = this.state;
    return (
      <React.Fragment>
        <div className="container-fluid superadmin-orderscomponent-main">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation
                displayLink={this.props.displayVendor ? 2 : 1}
              />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation displayText="All Active Vendors" />

              <div className="container-fluid" style={{ marginTop: "2%" }}>
                <h1>Add Order</h1>
                <br />
                <h5>User Information</h5>
                <br />
                <div className="row ">
                  <Form
                    className="col-xl-8 col-lg-10 col-md-12 pb-5"
                    //   style={{ padding: "1%" }}
                  >
                    <Form.Group>
                      <Row>
                        <Col sm={12}>
                          <FormControl variant="outlined" className="w-100">
                            <Select
                              inputProps={{
                                name: "code",
                              }}
                              value={0}
                            >
                              <option value={0}>Country</option>
                            </Select>
                          </FormControl>
                          <br />
                          <br />
                        </Col>
                        <Col md={6} sm={12}>
                          <FormControl variant="outlined" className="w-100">
                            <Select
                              inputProps={{
                                name: "state",
                              }}
                              value={0}
                            >
                              <option value={0}>State</option>
                            </Select>
                          </FormControl>
                          <br />
                          <br />
                        </Col>
                        <Col md={6} sm={12}>
                          <FormControl variant="outlined" className="w-100">
                            <Select
                              inputProps={{
                                name: "city",
                              }}
                              value={0}
                            >
                              <option value={0}>City</option>
                            </Select>
                          </FormControl>
                          <br />
                          <br />
                        </Col>
                        <Col sm={12}>
                          <FormControl variant="outlined" className="w-100">
                            <Select
                              inputProps={{
                                name: "code",
                              }}
                              value={0}
                            >
                              <option value={0}>Mc Donald’s</option>
                            </Select>
                          </FormControl>
                          <br />
                          <br />
                        </Col>
                        <Col md={6} sm={12}>
                          <TextField
                            id="first_name"
                            label="First Name"
                            variant="outlined"
                            className={`w-100 `}
                            name="first_name"
                          />
                          <br />
                          <br />
                        </Col>
                        <Col md={6} sm={12}>
                          <TextField
                            id="last_name"
                            label="Last Name"
                            variant="outlined"
                            className={`w-100 `}
                            name="last_name"
                          />
                          <br />
                          <br />
                        </Col>
                        <Col md={6}>
                          <Row>
                            <Col xs={4} className="pr-0">
                              <FormControl variant="outlined" className="w-100">
                                <Select
                                  value={0}
                                  // onChange={handleChangeCode}
                                  inputProps={{
                                    name: "code",
                                  }}
                                >
                                  <option value={0}>India (+91)</option>
                                </Select>
                              </FormControl>
                            </Col>
                            <Col xs={8}>
                              <Form.Group>
                                <TextField
                                  id="mobile_number"
                                  //id="outlined-basic"
                                  type="number"
                                  label="Phone Number"
                                  variant="outlined"
                                  className={`w-100 `}
                                  name="mobile_number"
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          <br />
                          <br />
                        </Col>
                      </Row>
                      <Row>
                        {/* {takeaway === 1 && ( */}
                        <Col sm={12}>
                          <h5>Order Type</h5>
                          <br />
                          <h6>Select one relevant option from below</h6>
                          <br />
                          <br />
                          <Row style={{ marginLeft: "2%" }}>
                            {orderTypes.map((data) => {
                              return (
                                <Col
                                  xs={3}
                                  sm={3}
                                  md={2}
                                  className={`take-away-order-select 
                                  ${
                                    ordertype === data.id &&
                                    `take-away-order-select-selected`
                                  }`}
                                  onClick={() => {
                                    this.setState({ ordertype: data.id });
                                  }}
                                  style={{
                                    padding: "1%",
                                    marginRight: "1%",
                                    marginBottom: "1%",
                                  }}
                                  key={data.id}
                                >
                                  <span>{data.title}</span>
                                </Col>
                              );
                            })}
                          </Row>

                          <br />
                          <br />
                        </Col>
                        {/* )} */}

                        <Col sm={12}>
                          {ordertype === 0 && (
                            <>
                              <h6>
                                Please select the option for your take away
                                order
                              </h6>
                              <br />
                              <br />
                              <div>
                                <span
                                  style={{ padding: "15px 18px 15px 18px" }}
                                  className={`take-away-order-select 
                                ${
                                  takeaway === 0 &&
                                  `take-away-order-select-selected`
                                }`}
                                  onClick={() => {
                                    this.setState({ takeaway: 0 });
                                  }}
                                >
                                  Now
                                </span>
                                &nbsp;&nbsp;
                                <span
                                  style={{ padding: "15px 18px 15px 18px" }}
                                  className={`take-away-order-select 
                                ${
                                  takeaway === 1 &&
                                  `take-away-order-select-selected`
                                }`}
                                  onClick={() => {
                                    this.setState({ takeaway: 1 });
                                  }}
                                >
                                  Later
                                </span>
                              </div>
                              <br />
                              <br />
                            </>
                          )}
                          <br />
                          <Row>
                            <Col xs={12}>
                              {takeaway === 1 && ordertype === 0 && (
                                <Row>
                                  <Col xs={6}>
                                    <TextField
                                      label="Select Date"
                                      variant="outlined"
                                      type="date"
                                      className="w-100"
                                      InputLabelProps={{
                                        shrink: true,
                                      }}
                                      name="date"
                                    />
                                  </Col>
                                </Row>
                              )}
                            </Col>
                          </Row>
                          {ordertype === 1 && (
                            <Row>
                              <Col xs={12}>
                                <h5>Vehicle Information</h5>
                                <br />
                                <p>
                                  Please enter your vehicle number to get your
                                  order delivered near by your vehicle. Do
                                  ensure that you are in or near by your
                                  vehicle.
                                </p>
                                <br />
                              </Col>
                              <Col xs={12}>
                                <div
                                  className="container-fluid"
                                  style={{ marginBottom: "1%" }}
                                >
                                  <Row>
                                    {vechileTypes.map((data) => {
                                      return (
                                        <Col md={3} key={data.id} xs={6}>
                                          <div
                                            className={`rounded-icons 
                                              ${
                                                vehicletype === data.id &&
                                                `rounded-icons-selected`
                                              }`}
                                            onClick={() => {
                                              this.setState({
                                                vehicletype: data.id,
                                              });
                                            }}
                                          >
                                            <img
                                              className="rounded-circle"
                                              src={data.icon}
                                              alt={data.title}
                                              width="100%"
                                            />
                                          </div>
                                          {data.title}
                                        </Col>
                                      );
                                    })}
                                  </Row>
                                </div>
                              </Col>
                              <Col xs={6}>
                                <TextField
                                  label="Vehicle Number"
                                  variant="outlined"
                                  className="w-100"
                                  name="vehicle_number"
                                />
                                <br />
                                <br />
                              </Col>
                              <Col xs={12}>
                                <Row>
                                  <Col xs={3}>
                                    <TextField
                                      label="Make"
                                      variant="outlined"
                                      className="w-100"
                                      name="make"
                                    />
                                    <br />
                                  </Col>
                                  <Col xs={3}>
                                    <TextField
                                      label="Model"
                                      variant="outlined"
                                      className="w-100"
                                      name="model"
                                    />
                                    <br />
                                  </Col>
                                  <Col xs={3}>
                                    <TextField
                                      label="Year"
                                      variant="outlined"
                                      className="w-100"
                                      name="year"
                                    />
                                    <br />
                                  </Col>
                                  <Col xs={3}>
                                    <TextField
                                      label="Color"
                                      variant="outlined"
                                      className="w-100"
                                      name="color"
                                    />
                                    <br />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          )}
                          {ordertype === 3 && (
                            <div className="container-fluid">
                              <h5>Table Information</h5>
                              <br />
                              <p>
                                Please enter your table number to get your order
                                delivered at your table.
                              </p>
                              <br />
                              <Row>
                                <Col xs={6}>
                                  <TextField
                                    label="Table Number/Seat Number"
                                    variant="outlined"
                                    className="w-100"
                                    name="seatnumber"
                                  />
                                  <br />
                                </Col>
                              </Row>
                            </div>
                          )}
                          {ordertype === 7 && (
                            <div className="container-fluid">
                              <h5>Delivery Address</h5>
                              <br />
                              <p>
                                Please enter your address to get your order
                                delivered. Do ensure that you are in or near by
                                address.
                              </p>
                              <br />
                              <Col xs={12}>
                                <div
                                  className="container-fluid"
                                  style={{ marginBottom: "1%" }}
                                >
                                  <Row>
                                    {deliveryTypes.map((data) => {
                                      return (
                                        <Col md={3} key={data.id} xs={6}>
                                          <div
                                            className={`rounded-icons 
                                              ${
                                                deliverytype === data.id &&
                                                `rounded-icons-selected`
                                              }`}
                                            onClick={() => {
                                              this.setState({
                                                deliverytype: data.id,
                                              });
                                            }}
                                          >
                                            <img
                                              className="rounded-circle"
                                              src={data.icon}
                                              alt={data.title}
                                              width="100%"
                                            />
                                          </div>
                                          {data.title}
                                        </Col>
                                      );
                                    })}
                                  </Row>
                                </div>
                              </Col>
                              <br />
                              <Row>
                                <Col md={6}>
                                  <Row>
                                    <Col xs={12}>
                                      <TextField
                                        label="House Number"
                                        variant="outlined"
                                        className="w-100"
                                        name="housenumber"
                                      />
                                      <br />
                                      <br />
                                    </Col>
                                    <Col md={6}>
                                      <TextField
                                        label="Area"
                                        variant="outlined"
                                        className="w-100"
                                        name="area"
                                      />
                                      <br />
                                      <br />
                                    </Col>
                                    <Col md={6}>
                                      <TextField
                                        label="Locality"
                                        variant="outlined"
                                        className="w-100"
                                        name="locality"
                                      />
                                      <br />
                                      <br />
                                    </Col>
                                    <Col md={6}>
                                      <TextField
                                        label="City"
                                        variant="outlined"
                                        className="w-100"
                                        name="city"
                                      />
                                      <br />
                                      <br />
                                    </Col>
                                    <Col md={6}>
                                      <TextField
                                        label="PIN/ZIP Code"
                                        variant="outlined"
                                        className="w-100"
                                        name="pincode"
                                      />
                                      <br />
                                      <br />
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </div>
                          )}
                          <div className="d-flex align-items-center pt-5">
                            <Button
                              variant="outline-secondary"
                              className="mr-4 px-5 py-2"
                              onClick={(e) =>
                                this.props.history.push("/superadminorders")
                              }
                            >
                              Cancel
                            </Button>
                            <Button
                              variant="danger"
                              className="px-5  py-2"
                              //onClick={(e) => handleShowTab("2")}
                              //type="submit"
                              onClick={() => {
                                this.props.history.push("/orderrequest");
                              }}
                            >
                              Next
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Form.Group>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const orderTypes = [
  { id: 0, title: "Takeaway" },
  { id: 1, title: "Curb-side" },
  { id: 2, title: "Skip-The Line" },
  { id: 3, title: "Dine-In" },
  { id: 4, title: "Buffet" },
  { id: 5, title: "Catering" },
  { id: 6, title: "Drive Thru" },
  { id: 7, title: "Delivery" },
];

const vechileTypes = [
  {
    id: 0,
    title: "4-wheeler",
    icon: require("../../../../assets/images/superadmin/ordericon/car.svg"),
  },
  {
    id: 1,
    title: "2-wheeler",
    icon: require("../../../../assets/images/superadmin/ordericon/scooter.svg"),
  },
  {
    id: 2,
    title: "3-wheeler",
    icon: require("../../../../assets/images/superadmin/ordericon/rikshaw.svg"),
  },
  {
    id: 3,
    title: "Others",
    icon: require("../../../../assets/images/superadmin/ordericon/taxi.svg"),
  },
];

const deliveryTypes = [
  {
    id: 0,
    title: "Indepdent House",
    icon: require("../../../../assets/images/superadmin/ordericon/house.svg"),
  },
  {
    id: 1,
    title: "HighRise",
    icon: require("../../../../assets/images/superadmin/ordericon/HighRise.svg"),
  },
  {
    id: 2,
    title: "Community",
    icon: require("../../../../assets/images/superadmin/ordericon/Community.svg"),
  },
  {
    id: 3,
    title: "Gated",
    icon: require("../../../../assets/images/superadmin/ordericon/gated.svg"),
  },
];

export default withRouter(SuperAdminCreateOrders);

// export default SuperAdminCreateOrders;
